module.exports = __webpack_public_path__ + "img/1.c2e0ec27.jpg";